module.exports = __webpack_public_path__ + "img/dataservice.c81b9ff.png";